const RzkBlockVC = () => {
  return (
    <div
      id="sobreThopen"
      className="w-screen bg-secondary-color py-[5rem] px-6 flex-col justify-center items-center"
    >
      {/* texto e imagem */}
      <div className="w-full max-w-[85rem] mx-auto flex flex-col lg:flex-row justify-center items-center gap-12 xl:gap-40">
        <div className="flex-1">
          <div className="w-full flex flex-col justify-start items-start text-left gap-6">
            <span className="text-white text-center lg:text-left w-full">
              Thopen Energia
            </span>
            <p className="text-white text-center lg:text-left w-full font-light text-[clamp(2rem,_2.34vw,_2.81rem)]">
              Transformando a forma como você consome energia
            </p>
            <img
              className="w-full h-full py-6 lg:hidden object-cover"
              src="/tim/images/placa-mobile.png"
              alt="RZK Energia - Foto de pinéis solares"
            />
            <p className="text-white text-xl text-center lg:text-left leading-9">
              A Thopen Energia surgiu com a missão de tornar a energia elétrica
              mais eficiente, econômica e descomplicada. Com o objetivo de
              promover uma economia de baixo carbono através de fontes
              renováveis e sustentáveis, nossa equipe dedicada e voltada para o
              cliente está comprometida em democratizar o acesso à energia limpa
              para todos.
            </p>
          </div>
        </div>
        <div className="flex-1 rounded-xl overflow-hidden">
          <img
            className="w-full h-full hidden lg:block"
            src="/tim/images/placa_pc.png"
            alt="RZK Energia - Foto de pinéis solares"
          />
        </div>
      </div>

      {/* ícones */}
      <div className="w-full h-full max-w-[60rem] m-auto flex flex-col md:flex-row justify-between items-center gap-3 mt-4 md:mt-14">
        <div className="max-w-[143px] h-[13.875rem] flex-col justify-start items-center gap-[13px] inline-flex space-y-2">
          <img
            className="w-[89.13px] h-[92px]"
            src="/tim/images/paineis-solares.svg"
            alt="Ícone de painel solar"
          />
          <div className="text-center">
            <span className="text-white text-base font-normal">
              Geramos energia <br />
              nas nossas usinas <br />
            </span>
          </div>
        </div>

        <div className="max-w-[143px] h-[13.875rem] flex-col justify-start items-center gap-[13px] inline-flex space-y-2">
          <img
            className="w-[89.13px] h-[90px]"
            src="/tim/images/torre-de-transmissao.svg"
            alt="Ícone de torre de transmissão"
          />
          <div className="text-center">
            <span className="text-white text-base font-normal">
              A distribuidora recebe a energia gerada e a entrega para você
            </span>
          </div>
        </div>

        <div className="w-[143px] h-[13.875rem] flex-col justify-start items-center gap-[13px] inline-flex space-y-2">
          <img
            className="w-[89.13px] h-[89px]"
            src="/tim/images/eletricidade.svg"
            alt="Ícone de eletricidade"
          />
          <div className="text-center">
            <span className="text-white text-base font-normal">
              Você recebe a energia e paga menos nas contas todos os meses.
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RzkBlockVC;
